export default __webpack_public_path__ + "static/media/sf-with-invoice.cee0afc2.png";